import { CHUNK_SIZE } from "@eldrun/worldgen";
import { chunkOrigin } from "./tile.ts";

/** Distâncias máximas de cada LOD (doc 04): 160 / 320 / 640 m; além disso, L3. */
export const LOD_DISTANCES: readonly number[] = [160, 320, 640];
export const LOD_HYSTERESIS = 16;

/** Distância horizontal da câmera até a AABB do chunk (0 dentro dele). */
export function distanceToChunk(cameraX: number, cameraZ: number, cx: number, cz: number): number {
  const minX = chunkOrigin(cx);
  const minZ = chunkOrigin(cz);
  const dx = Math.max(minX - cameraX, 0, cameraX - (minX + CHUNK_SIZE));
  const dz = Math.max(minZ - cameraZ, 0, cameraZ - (minZ + CHUNK_SIZE));
  return Math.sqrt(dx * dx + dz * dz);
}

/**
 * LOD desejado com histerese: só muda de faixa quando a distância passa o limite em
 * LOD_HYSTERESIS metros, evitando troca constante na fronteira.
 */
export function selectLod(distance: number, current: number | undefined, alwaysCoarse = false): number {
  if (alwaysCoarse) return LOD_DISTANCES.length;
  let target = LOD_DISTANCES.length;
  for (let lod = 0; lod < LOD_DISTANCES.length; lod++) {
    if (distance <= (LOD_DISTANCES[lod] as number)) {
      target = lod;
      break;
    }
  }
  if (current === undefined || current === target) return target;
  if (target > current) {
    // Afastando: só fica mais grosso depois de passar o limite + histerese.
    const limit = LOD_DISTANCES[current];
    return limit !== undefined && distance <= limit + LOD_HYSTERESIS ? current : target;
  }
  // Aproximando: só fica mais fino depois de entrar limite − histerese.
  const limit = LOD_DISTANCES[target] as number;
  return distance < limit - LOD_HYSTERESIS ? target : current;
}
